//call this fille in ac-tiered-qty-global.liquid file after this file call ac-filter-tiers.js
//   <script type="text/javascript" src="{{ 'ac-filter-tiers.js' | asset_url}}" defer></script>
//   <script type="text/javascript" src="{{ 'ac-quickviewVariantChangePrice.js' | asset_url}}" defer></script>
let productID = ''
  $(document).ready(function() {
    document.addEventListener("click", function (e) {
  const target = e.target.closest(".js_add_qv");
  if (!target) return;

  console.log("Quick View Clicked:", target.dataset.id);
});
  var VarintChangeSelectorPDpage = '#content_quickview form[action="/cart/add"] .swatches-select li,#content_quickview form[action="/cart/add"] select,#content_quickview form[action="/cart/add"] input,#content_quickview form[action="/cart/add"] .flex.wrap .plus,#content_quickview form[action="/cart/add"] .flex.wrap .minus';
 
let quickviewTimeout;

$(document).on('click change', VarintChangeSelectorPDpage, function () {

  clearTimeout(quickviewTimeout);

  quickviewTimeout = setTimeout(() => {
    
    getProductId();
  }, 500);

});



(function () {
  let observerAttached = false;

  const mainObserver = new MutationObserver(mutations => {

    // check if quickview element exists in mutation
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        const quickView = node.closest("#content_quickview") || node.querySelector("#content_quickview");
        if (!quickView) continue;

        // price element
        const priceNode = quickView.querySelector("#price_qv");
        if (!priceNode ) return;

        observerAttached = true; // prevent duplicate observer attaching

        // fire first time instantly
        getProductId();

        // observe price changes
        const priceObserver = new MutationObserver(() => {
          getProductId();
        });

        priceObserver.observe(priceNode, {
          subtree: true,
          childList: true,
          characterData: true
        });

      }
    }
  });

  mainObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();






(function () {
  function setupQuickviewObserver() {
    // 1) If quickview is already on the page when this runs, call getProductId(); once
    const existing = document.querySelector("#content_quickview");
    if (existing) {
      getProductId();
    }

    // 2) Observe future DOM changes and detect when #content_quickview is added
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type !== "childList") return;

        mutation.addedNodes.forEach(function (node) {
          // Only care about element nodes
          if (!(node instanceof HTMLElement)) return;

          // Case 1: the node itself *is* #content_quickview
          if (node.id === "content_quickview") {
            getProductId();
            return;
          }

          // Case 2: #content_quickview exists inside this added subtree
          const qv = node.querySelector && node.querySelector("#content_quickview");
          if (qv) {
            getProductId();
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Make sure DOM is ready before we attach the observer
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupQuickviewObserver);
  } else {
    setupQuickviewObserver();
  }
})();


});






//  var VarintChangeSelectorPDpage = 'form[action="/cart/add"] .swatches-select li,form[action="/cart/add"] .swatches-select li,form[action="/cart/add"] select, form[action="/cart/add"] input, form[action="/cart/add"] .flex.wrap .plus, form[action="/cart/add"] .flex.wrap .minus';
// jQuery(document).on("click", VarintChangeSelectorPDpage, function () {
//     // Find the closest parent having data-product-id
//     
//     let parentVariant = jQuery(this).closest("variant-selects[data-product-id]");
    
//    productID = parentVariant.attr("data-product-id");
        


// });
var getProductId = function() {
        const checkQuickview = setInterval(() => {
  const el = jQuery('#content_quickview [id*="productqv-"]'); // wildcard for dynamic id

  if (el.length) {
    let id = el.attr("id");
    productID = id.split("productqv-")[1];
    changePrice()
    clearInterval(checkQuickview);
  }
}, 200);
} 
let customerMemberOrNot = false;
var lastselectedVariant = false;
var changePrice = function(){
    
    VarintChangeSelectorPDpage = '.row.product form[action="/cart/add"] .swatches-select li,.row.product form[action="/cart/add"] select,.row.product form[action="/cart/add"] input,.row.product form[action="/cart/add"] .flex.wrap .plus,.row.product form[action="/cart/add"] .flex.wrap .minus';
 
       if (productID) {
      var selectedVariant = getSelectedVariant();
      let tempTierObj = window.productsById[productID];
      if(!tempTierObj)return
      //if (lastselectedVariant == selectedVariant) return
      lastselectedVariant = selectedVariant
       customerMemberOrNot = globalFields.customerTagsCheck();
     let currencyRate = Shopify.currency.rate;
    currencyRate = Number(currencyRate);
    if(selectedVariant == ""){ 
        return
        //   let id_= Object.keys(window.variantsPriceMap)
        //   selectedVariant = id_[0];
        }
      var mainProductPrice = tempTierObj.variantsPrices[selectedVariant];;
       mainProductPrice = CalculateTradePlusDiscount(mainProductPrice);// give trade+ discount
      
      let productPriceWithoutMonney = mainProductPrice
      if (typeof mainProductPrice == 'number') {
       mainProductPrice  = globalFields.ConvertToFixedDecimalString(mainProductPrice)
      }
      var mainProductPriceWithMoney  = globalFields.formatMoney(mainProductPrice, globalFields.amount);
        var originalChangeQty = jQuery('#content_quickview input[name="quantity"]').val();
        originalChangeQty = Number(originalChangeQty);
        if(isNaN(originalChangeQty)){
        	originalChangeQty = 1;
        }
        var updatedItemPrice = 0
        let tierData = tempTierObj.product_metafields;
        let productMetafieldValidation = filterProductMetafields(tierData, Number(selectedVariant));

        if (selectedVariant != null && productMetafieldValidation != undefined  && productMetafieldValidation.status && selectedVariant != "") {
         let tierObj = productMetafieldValidation;
          if (tierObj && tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && tierObj?.tier_min.length ) {
            for (i = 0; i < tierObj.tier_min.length; i++) {
              var tierPrice = parseFloat(tierObj.tier_values[i]);
              var minTier = parseInt(tierObj.tier_min[i]), maxTier = tierObj.tier_max[i] != 'max' ? parseInt(tierObj.tier_max[i]) : tierObj.tier_max[i];
              var updatedLinePrice = 0, condition1 = false, condition2 = false;
              // var originalPrice_ = (mainProductPrice / 100);
              //     originalPrice_ = originalPrice_;
				 var originalPrice_ = Number(mainProductPrice );
                  condition1 = originalChangeQty >= minTier;
                  condition2 = maxTier == "max" || originalChangeQty <= maxTier;
              if (condition1 && condition2) { break; }
            }
           
            if (condition1 && condition2) {
                if (tierObj.discount_type == 'percentage') {
                    var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(originalPrice_)));
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - originalPriceCut);
                }
                else if (tierObj.discount_type == 'fixed') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - parseFloat(tierPrice * currencyRate));
                }
                else if (tierObj.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice * currencyRate));
                }
              
                 WriteProductDiscountHtml(updatedItemPrice,productPriceWithoutMonney)
                updatedItemPrice = globalFields.formatMoney(Number(updatedItemPrice).toFixed(2), globalFields.amount);
            }
            else{
              WriteProductDiscountHtml(productPriceWithoutMonney,0)
            }
          }else{ WriteProductDiscountHtml(productPriceWithoutMonney,0)}
          }
        else{
            WriteProductDiscountHtml(productPriceWithoutMonney,0)
          } 
          }
  }//end changePrice function

  

    function CalculateTradePlusDiscount(productPrice) {
          let product_id = productID
          let originalPrice_ = Number(productPrice);
          let TradeDiscountTier = globalFields.AllProductsMetafield;
          let tierDiscountAmount = globalFields.AllProductsMetafield != '[]' && globalFields.AllProductsMetafield.status ? Number(TradeDiscountTier.tier_values[0]) :0 ;

        /* if product have custom price start*/
          let customProductPrice = $('#content_quickview .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true .price_range').text()
         let tempCustomProductPrice = $('#content_quickview .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true .price_range del').text()
          if (tempCustomProductPrice) {
              customProductPrice = $('#content_quickview .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true .price_range ins').text()
          }

          
         customProductPrice = customProductPrice !== undefined && customProductPrice !== '' 
          ? parseFloat(customProductPrice.replace(/[^\d.,]/g, '').replace(/,/g, '')) 
          : 0;
            if (originalPrice_ == 0 || originalPrice_ != customProductPrice) {
            originalPrice_ = customProductPrice
            }  /* if product have custom price end*/
        
          var product_exclude =   isExcludedOnProductPage();
          customerMemberOrNot = globalFields.customerTagsCheck();
          if (!product_exclude && customerMemberOrNot == 'Trade+' && globalFields.isCustomer && globalFields.TradeMemberCustomer) {
              let TradePlusDiscount = originalPrice_ * tierDiscountAmount/100;
              originalPrice_ =  originalPrice_ - TradePlusDiscount;
          }
          
          return originalPrice_
      }//end of CalculateTradePlusDiscount

  

    function WriteProductDiscountHtml(price,productPrice) {
              let ProductUpdatedPrice = globalFields.formatMoney(price.toFixed(2), globalFields.amount);
               let ProductOriginalPrice = productPrice > 0 ? `<s>${globalFields.formatMoney(productPrice.toFixed(2), globalFields.amount)}</s>  `:''
              $('.ac-anncode-price-qv').remove(); 
             // extra price hide start
              $('#content_quickview .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true #price_qv').hide(); 
            //document.querySelector('#content_quickview .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true #price_qv').style.setProperty('display', 'none', 'important');

            document.addEventListener('DOMContentLoaded', () => {
                const element = document.querySelector('#content_quickview .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true #price_qv');
                if (element) {
                    element.style.setProperty('display', 'none', 'important');
                }
            });

      
              $('#cart-form_qv .price.price_varies').hide();
             //   document.querySelector('#cart-form_qv .price.price_varies').style.setProperty('display', 'none', 'important');
                document.addEventListener('DOMContentLoaded', () => {
                const element = document.querySelector('#cart-form_qv .price.price_varies');
                if (element) {
                    element.style.setProperty('display', 'none', 'important');
                }
            });
            // extra price hide end
             var product_exclude = isExcludedOnProductPage();
             
             if(!product_exclude && globalFields.isCustomer && globalFields.TradeMemberCustomer && customerMemberOrNot == 'Trade+'){
                jQuery('#content_quickview .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true').append(`<span class="ac-anncode-price-qv">
                  ${ProductOriginalPrice}
                  <span > ${ProductUpdatedPrice} ${globalFields.VatPrice}</span> 
                  <span style="margin-left: 10px;font-size: initial;position: absolute;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 63 60">
                  <image width="63" height="60" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA8CAYAAADRy2JxAAAEjElEQVRoQ+2bTUhVQRTHR1o8SJAMBCFFUQjKQvuAoE0gSO2EilpKgtuy3PvQvVltC8FlUUG7IBDdKAVBIX0QvFAyECTSFwRCUvf/ah73jTNzzv2ae+/LAcHHmztzfvd8zrn3Nfz2hvhPR8MefB1r/ufbd2J75UvlD6N58IIodLZX/jdqfmeznKlbsu9AUyB5yguLYvVmUQBejtYbI6Lj9kT1cw08gNcmp0R5frHmokC7JjQZ2uqamRZN585adwAsoAHvHyr4Ls1/ujgsvj97npD40ZeF9k9/+6hdSCpuY/ahUK0W4G3jY0K1nqrmcceWTw5ElzDBFUzwgC0Nj2oV1zJ0xTP1yV3gNZpfv3tfrN4qJih69KV18FAaLFYGNP8u+3t7xNG5J1rwGvi1iSnx1fP3LA/4fV/pZVVEuCg0rgvOFHju4A95fttWHKvAw1IRnHXgsJDjr19UU5pJoVWft2kei7VeHyEXS9JqGvt6BLTJAT/8dIbMCmzNH5l7zFosSXi5NhWbAI5ChjNIzdvSC2eDOOdszD7ygvK41tSxjy6X2/bPDTyi+vv+S7GBs8w+C5qnwDmRXWcBmdc8ovnyqQFtHgcQN7LnDt5WuUnw7pk7lQCHWr48vyR2tv4eyGANqO5y6/OoOBHdTUPmfVNpDvgu7+aEzvNp+TyV0vxgprmU7Jn0eSrAocxFBSdPaaYCLXfw8HOkNH8Twm+2AFIruLqB/+wdVFDMmAY6MShm/KMu4Ck/R1SH1tXhBF6mkx8LS+LX5lZFBvgf/poHz0eq/3EeRz439Q5h7idKr7RncyfwVOrBTUD6ofKrqjkAoyGh9t3882wHFifwEMbWOZHCosDomJ5gWwLVSKEOLM7gJSCn2UkJjbWgbaxlMnc1rekCoXN4CEFpTJaZpj4aldZwPed8ngq81NyH/svWGhpuAAj5pEROpm4ex3JsSnBS5MB0qRsAQWABshUVh7lTN9EJPNcC5A0odLRHiu6p5Hmrbf8LXhwLOOgVK7YqzlTMmPZPzedVgdBLR/QOO1T34KyTGXgISxVDNiB/b54DnnrA0wnJqQPU68L24jKleUBxcrgKH/b5QObgAYbDypvuMyzrDRrk/ItmEh4CUsdUzAkT5HIBDyHx3N/UmcH3YYJcbuBt5m87p7P8xZuUWbOXAKb0F1XrWB+Fla4X4Ky8pbSke/LCOa5S69piivoyg7qW09Y1Slo0KOXQNSMpWP/3VDDFm1tIn6bhFB5CIPUhBkTVOgWOvfC0xtZScw4vtR9F6xxwTi/AObxsVqK5EfStSm7dYHrvLlWfl5vjBqQNDlmcaz5IQAsS3DCXq3G5bi7guT6ue8XUdrNJeFyMF//U5mNYDQa9LilwltljEvIlHkKg9+Zq4HHY+r0H1pcTwpi6X36W5l0BB90nqI8HjvZBBXI1Pyo42+xdAXH3iQO8Bj5q15UreNR5cYHXwOODrLujCpjU9XGC74JHt6V0bTRzv69BNYgc3jJ0NVRlaFKG9tdVaAxsr6wlpcBA6xY620Rj77FYoaUAez8qDKSKOpr8B0bXpon91epwAAAAAElFTkSuQmCC"></image>
                  </svg>
                  <span style="display: inline-grid;line-height: 1;font-size: smaller;position: absolute;"> <b>Trade</b> <b> Member </b></span> </span></span>`);
             }
             else{
            
                jQuery('#content_quickview .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true').append(`<span class="ac-anncode-price-qv">${ProductOriginalPrice}<span >${ProductUpdatedPrice} ${globalFields.VatPrice}</span></span>`);
             }
            const elements = document.querySelectorAll('#content_quickview .has_dpo_options #price_qv ~ *');
          elements.forEach(element => {
              element.style.setProperty('display', 'block', 'important');
          });
  
}  //end WriteProductDiscountHtml function
 
  function isExcludedOnProductPage() {
     let product_Excluded = false;
     let product_id = productID;
    let TradeDiscountTier = globalFields.AllProductsMetafield;
    product_Excluded = globalFields.AllProductsMetafield != '[]'  && globalFields.AllProductsMetafield.status? TradeDiscountTier?.excludeProducts.some(product => product.id  == `gid://shopify/Product/${product_id}` || product.id == product_id) : product_Excluded;
    return product_Excluded
}
  


function getSelectedVariant() {
    try {
        // Define your selectors cleanly
        const variantSelector = `input[name^="id"]:checked,
                                 select[name^="id"],
                                 input[name="id"],
                                 input[type="hidden"][name^="id"]`;

        // Try first form sources
        const primaryForm = jQuery('form[action="/cart/add"], #add-to-cart-form');
        let selectedVariant = primaryForm.find(variantSelector).val();

        // If empty/undefined/null then fallback
        if (!selectedVariant) {
            const secondaryForm = jQuery('form[data-type="add-to-cart-form"], #add-to-cart-form');
            selectedVariant = secondaryForm.find(variantSelector).val();
        }

        // Final safety check
        if (!selectedVariant) {
            return null;
        }

        return selectedVariant;

    } catch (err) {
        console.error("Error while getting selected variant:", err);
        return null;
    }
}



getProductId();
